import React, { FC, ComponentType } from 'react';
import './signup_user.scss';
import { getParametersFromUrl } from '../../../utils/url-utils/urlUtils';
import { SignUpUserFromHome } from './SignUpUserFromHome';
import { SignUpUserDefault } from './SignUpUserDefault';
import { SignUpUserFromLawyer } from './SignUpUserFromLawyer';
import { SignUpUserFromCampaign } from './SignUpUserFromCampaign';

// Quick solution. We should use different routes for each component and go through the router
export const SignUpUser: FC = () => {
  const sourcePageToComponentMap: { [key: string]: ComponentType } = {
    Home: SignUpUserFromHome,
    Lawyer: SignUpUserFromLawyer,
    Campaign: SignUpUserFromCampaign,
  };
  const { sourcePage } = getParametersFromUrl(window.location.search);
  const ComponentToRender =
    sourcePageToComponentMap[sourcePage] || SignUpUserDefault;

  return <ComponentToRender />;
};
